import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from "@env/environment";
import { map } from 'rxjs/operators';
import { Organization } from 'src/models/organization.model';

const API_URL = `${environment.api.baseUrl || ""}${environment.api.services.organization}`;

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  constructor(private httpClient: HttpClient) { }

  getOrgInfo(organizationCode: string = "") {
    //return Organization model
    let headers = new HttpHeaders()
    headers = headers.append('content-type', 'application/json')

    // Initialize Params Object
    let params = new HttpParams();
    params = params.append('organizationCode', organizationCode);

    //let url = "assets/test-organization.json";
    let url = API_URL;

    return this.httpClient.get<Organization>(url, {
      params: params,
      headers: headers
    }).pipe(map((res: Organization) => {

      let organization = new Organization;
      organization = res;

      return organization;

    }));;
  }
}
